import { throttleTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { Directive, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[appNoDblClick]',
})
export class NoDblClickDirective implements OnDestroy {
  @HostListener('click', ['$event'])
  clickEvent (e: Event) {
    e.preventDefault(); 
    this.click.next();
  };

  @Output()
  onClick = new EventEmitter();
  
  click: Subject<void> = new Subject();
  _click: Subscription = this.click
    .pipe(throttleTime(500))
    .subscribe(() => this.onClick.emit());
  
  ngOnDestroy () {
    if (this._click) this._click.unsubscribe();
    if (this.click) this.click.unsubscribe();
  };
}
